<template>
    <BasePromotionCard
        title="Add to your network"
        description="Track this person so we can keep notes and surface them in future conversations."
        cta-label="Add connection"
        cta-href="/people/new/">
        <template #icon>
            <svg class="h-4 w-4" fill="none" viewBox="0 0 24 24" stroke-width="2" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M18 9v3m0 0v3m0-3h3m-3 0h-3m-2-5a4 4 0 11-8 0 4 4 0 018 0zM3 20a6 6 0 0112 0v1H3v-1z" />
            </svg>
        </template>
        <template #draft>
            <div class="font-medium text-slate-900">{{ data.name }}</div>
            <div v-if="data.job_title" class="text-slate-600">{{ data.job_title }}</div>
            <p v-if="data.summary" class="mt-1 text-slate-600">{{ data.summary }}</p>
        </template>
    </BasePromotionCard>
</template>

<script setup lang="ts">
import { computed } from "vue";

import type { PromoteConnectionCreationResult } from "../../types";
import BasePromotionCard from "./BasePromotionCard.vue";

const props = defineProps<{ result: PromoteConnectionCreationResult; toolName: string }>();

const data = computed<PromoteConnectionCreationResult>(() => props.result);
</script>
